import { render, staticRenderFns } from "./ViewOrganizationUserP2POwnerVehicles.vue?vue&type=template&id=49cd6264"
import script from "./ViewOrganizationUserP2POwnerVehicles.vue?vue&type=script&lang=js"
export * from "./ViewOrganizationUserP2POwnerVehicles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports